import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import CardsPopup from "./CardsPopup";
import { CC, InputContainer } from "./MoveOut.styled";
import cc from "../../assets/ccIcon.svg";
import { Label } from "../../screens/complaint/Complaint.styled";
import cvv from "../../assets/cvv.svg";
import CloseIcon from "../../assets/CloseIcon.svg";

import OtpInput from "react18-input-otp";

import General from "../../stores/GeneralStore";
import RefundAndTransfer from "../../stores/RefundAndTransferStore";

import { Modal } from "@mui/material";
import NoMobileModalExist from "./NoMobileExistModal";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { AnyAaaaRecord } from "node:dns";
import { generateUUID } from "../../../src/utils/utilityHelper";
import { OtpProtectedOperations } from "../../../src/utils/constants";
// import CashPayout from "../RefundTabs/CashPayout";
interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  isModal?: Boolean;
  refund?: Boolean;
  cashPayout?: any;
  isMovein?: Boolean;
  onClose?: React.MouseEventHandler<HTMLImageElement>;
  onVerify?: any;
  registrationLoader?: Boolean;
  setCashPayoutResponse?: any;
  handleCashPayout?: any;
  premiseId: string;
  email: string;
  mobile: string;
  personID: string;
  isMoveOut?: boolean;
}

const VerifyAndPay = ({
  isModal = true,
  refund = false,
  cashPayout = false,
  isMovein = false,
  onClose,
  onVerify,
  setCashPayoutResponse,
  Previous,
  premiseId,
  email,
  mobile,
  personID,
  registrationLoader,
  isMoveOut,
}: Props) => {
  const [verified, setVerified] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [numbers, setNumbers] = useState("");
  const [open, setOpen] = useState<boolean>(false);
  const [verifyLoader, setVerifyLoader] = useState<boolean>(false);
  const transactionIdRef = useRef<string>(generateUUID());

  // const handleClose = () => {
  //   if(withPayment)
  //     setOpen(false);
  //   setLoading(true);
  //   setVerified(false);
  // };
  // const handleToggle = () => {
  //   setOpen(!open);

  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1500);
  // };

  const handleChange = (otpConfirm: any) => {
    const regex = /^[0-9]+$/;

    if (otpConfirm.length < numbers.length) {
      // Backspace pressed
      setNumbers(otpConfirm);
    } else if (regex.test(otpConfirm)) {
      // Normal input
      setNumbers(otpConfirm);
    }
  };
  // const handleCCVerification = () => {
  //   setCcVerified(true);
  //   if(withPayment)
  //     setOpen(false);
  //   // setLoading(false);
  // };

  const handleVerification = async () => {
    if (numbers.length !== 6) return;

    setVerifyLoader(true);

    let res;

    try {
      if (cashPayout) {
        res = await RefundAndTransfer.cashPayout({
          errorId: "verifyCashPayoutOtpError",
          data: {
            oneTimePasswordConfirm: numbers,
            transactionId: transactionIdRef.current,
          },
        });
      } else if (refund) {
        res = await General.verifyRefundOTP({
          errorId: "verifyRefundOTPError",
          data: { numbers, transactionId: transactionIdRef.current },
        });
      } else if (isMovein) {
        console.log("Sending OTP for Move In");
        res = await General.verifyOTPRegistration({
          errorId: "verifyOTPError",
          data: {
            numbers,
            personID,
            transactionId: transactionIdRef.current,
            operation: getOperationId(),
          },
        });
      } else {
        res = await General.verifyOTP({
          errorId: "verifyOTPError",
          data: { numbers, transactionId: transactionIdRef.current },
        });
      }

      const status = res?.result?.status;
      const message = res?.result?.message;

      if (cashPayout && status === "SUCCESS") {
        onVerify(res);
      } else if (message === "Success") {
        onVerify(transactionIdRef.current);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
    } finally {
      setVerifyLoader(false);
    }
  };

  useEffect(() => {
    if (cashPayout) {
      RefundAndTransfer.sendOtpForCashPayout({
        errorId: "cashpayouterror",
        data: {
          transactionId: transactionIdRef.current,
          operation: getOperationId(),
        },
      }).then((result) => {
        console.log("result", result);

        // setOtp(result?.result);
      });
    } else {
      if (mobile || email || personID) {
        console.log("Sending Otp");
        General.sendOTP({
          errorId: "sendOTPError",
          data: {
            premiseId,
            email,
            mobile,
            personID,
            transactionId: transactionIdRef.current,
            operation: getOperationId(),
            // useProvidedContactInfo: isMovein ? true : false,
          },
        });
      }
    }
  }, []);

  /**
   * Returns the appropriate OTP-protected operation ID based on the current context.
   * Priority is determined in the following order: refund > cash payout > move-in > move-out.
   * If none apply, defaults to 'None'.
   */
  const getOperationId = () => {
    const operations = [
      { condition: refund, value: OtpProtectedOperations.Refund },
      { condition: cashPayout, value: OtpProtectedOperations.CashPayout },
      { condition: isMovein, value: personID ? OtpProtectedOperations.MoveInRegistration : OtpProtectedOperations.MoveInRegistrationWithoutPersonId },
      {
        condition: isMoveOut,
        value: OtpProtectedOperations.MoveOutRegistration,
      },
    ];

    return (
      operations.find((op) => op.condition)?.value ??
      OtpProtectedOperations.None
    );
  };

  const resendOtp = () => {
    setNumbers("");
    if (cashPayout) {
      RefundAndTransfer.sendOtpForCashPayout({
        errorId: "cashpayouterror",
        data: {
          transactionId: transactionIdRef.current,
          operation: getOperationId(),
        },
      });
    } else {
      General.sendOTP({
        errorId: "sendOTPError",
        data: {
          premiseId,
          email,
          mobile,
          personID,
          transactionId: transactionIdRef.current,
          operation: getOperationId(),
          // useProvidedContactInfo: isMovein ? true : false,
        },
      });
    }
  };
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div>
      {mobile || email || personID ? (
        <div
          style={{
            // width: "55%",
            // overflow: "auto",
            margin: "auto",
            minHeight: "60vh",
          }}
        >
          {isModal && (
            <div
              style={{
                // height: '20%',
                width: "100%",
                justifyContent: "space-between",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                background: "#101e8e",
                display: "flex",
                alignItems: "center",
              }}
            >
              <h1
                style={{
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#fff",
                  justifySelf: "flex-start",
                }}
              >
                {General?.codeLabels["cm_saved_cards"]?.label !== undefined
                  ? General?.codeLabels["cm_saved_cards"]?.label
                  : "Saved Cards"}
              </h1>
              <img src={CloseIcon} alt="" onClick={onClose} />
            </div>
          )}

          <TabContainer
            style={{
              width: "100%",
              padding: "0",
              display: "flex",
              gap: "0.5rem",
              flexDirection: "column",
              justifyContent: "center",
              marginTop: "50px",
              alignItems: "center",
              backgroundColor: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
            }}
          >
            <>
              <Typography
                component="p"
                sx={{
                  fontWeight: "700",
                  fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  color: General.contrast.contrastBackground
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                  textAlign: General?.isLargeScreen ? "" : "center",
                }}
              >
                {!(isMovein && email && mobile) &&
                  (General?.codeLabels["cm_otp_send"]?.label !== undefined
                    ? General?.codeLabels["cm_otp_send"]?.label
                    : "Please Enter The One-Time Password (OTP)")}
              </Typography>
              <p
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "400",
                  fontSize: `${1.25 * General.accessibility.fontSize}rem`,
                  fontStyle: "normal",
                  fontFamily: "Segoe UI",
                  color: General.contrast.contrastBackground
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                }}
              >
                {mobile && email
                  ? General?.codeLabels["cm_otp_both"]?.label
                  : mobile
                  ? General?.codeLabels["cm_otp_mode_mobile"]?.label
                  : email
                  ? General?.codeLabels["cm_otp_mode_email"]?.label
                  : General?.codeLabels["cm_otp_mode_mobile"]?.label}
                <br />
                {mobile
                  ? `******${mobile.slice(-4)}`
                  : email
                  ? `${email.substring(0, 2)}****@${email.split("@")[1]}`
                  : ""}
              </p>

              <InputContainer
                style={{ justifyContent: "center" }}
                className="ServiceVerifyPayOTP"
              >
                <OtpInput
                  inputStyle={{
                    direction: "ltr",
                    background: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : "#edf4f6",
                    color: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : General?.ColorAss,
                  }}
                  value={numbers}
                  onChange={handleChange}
                  numInputs={6}
                  isInputNum={true}
                />
              </InputContainer>

              <p
                style={{
                  marginTop: "1rem",
                  width: "100%",
                  textAlign: "center",
                  fontSize: `${1.25 * General.accessibility.fontSize}rem`,
                  color: General.contrast.contrastBackground
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                }}
              >
                {General?.codeLabels["cm_mob_otp2min"]?.label !== undefined
                  ? General?.codeLabels["cm_mob_otp2min"]?.label
                  : "If you do not receive mobile OTP within 5 minutes"}{" "}
                &nbsp;
                <span
                  onClick={resendOtp}
                  style={{
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: `${1.25 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastBackground
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_mob_resendotp"]?.label !== undefined
                    ? General?.codeLabels["cm_mob_resendotp"]?.label
                    : "Resend OTP"}
                </span>
              </p>
              <ButtonsContainer
                style={{
                  flexDirection: General?.isLargeScreen ? "row" : "column",
                  width: General?.isLargeScreen ? "50%" : "100%",
                  marginTop: "1rem",
                }}
              >
                <ButtonSecondary
                  style={{
                    width: General?.isLargeScreen ? "45%" : "100%",
                    padding: "auto",
                    fontSize: `${1.25 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastBackground
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    background: General.contrast.contrastColor
                      ? General.contrast.contrastBackground
                      : "#fff",
                    border: `1px solid ${General.contrast.contrastColor}`,
                  }}
                  onClick={Previous}
                >
                  {General?.codeLabels["cm_back"]?.label !== undefined
                    ? General?.codeLabels["cm_back"]?.label
                    : "Back"}
                </ButtonSecondary>
                <ButtonSecondary
                  style={{
                    width: General?.isLargeScreen ? "45%" : "100%",
                    padding: "auto",
                    marginTop: General?.isLargeScreen ? "" : "1rem",
                    fontSize: `${1.25 * General.accessibility.fontSize}rem`,
                    color: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : "#fff",
                    background: General.contrast.contrastBackground
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    border: "none",
                  }}
                  onClick={handleVerification}
                >
                  {verifyLoader || registrationLoader ? (
                    <Spinner width="30px" height="30px" />
                  ) : General?.codeLabels["cm_verifybtn_verify"]?.label !==
                    undefined ? (
                    General?.codeLabels["cm_verifybtn_verify"]?.label
                  ) : (
                    "Verify"
                  )}
                </ButtonSecondary>
              </ButtonsContainer>
            </>
          </TabContainer>
        </div>
      ) : (
        <Modal
          open={true}
          onClose={Previous}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <NoMobileModalExist onValidateClick={Previous} />
        </Modal>
      )}
    </div>
  );
};

export default VerifyAndPay;
